<template>
  <div class="flex items-center">
    {{ params.value | toHourFormat }}
  </div>
</template>

<script>

  export default {
    name: "CellRendererTotalSecond",
  };
</script>
